import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Manage roles' | translate }}</h1>
        </div>
        <user-group-list-table
            list="vm.list"
            classifier-type="vm.classifierType"
            translations="vm.translations"
            edit-state="vm.editState"
            add-state="vm.addState">
        </user-group-list-table>
`
})
export default class {
    constructor ($translate, CLASSIFIER_ENUM, ListFactory, ClassifierResource) {
        this.$translate = $translate;
        this.ClassifierResource = ClassifierResource;
        this.ListFactory = ListFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.ClassifierResource.query.bind(this.ClassifierResource));
        this.list.fetch({ type: this.CLASSIFIER_ENUM.KEYS.ROLE, doUpdateUserCounts: true });
        this.classifierType = this.CLASSIFIER_ENUM.KEYS.ROLE;
        this.editState = 'authorized.user.group.detail.role';
        this.addState = 'authorized.user.group.add.role';
        this.initTranslationTokens();
    }

    initTranslationTokens () {
        const { $translate } = this;
        this.translations = {
            addLabel: $translate.instant('user.Add role'),
            classifierName: $translate.instant('user.Role'),
            deleteMessage: $translate.instant('classifier.Are you sure you wish to delete the role?'),
            deleteExternalMessage: $translate.instant('classifier.Are you sure you wish to delete the external role?'),
            deleteSuccessMessage: $translate.instant('classifier.Role deleted')
        };
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/list/role/index.js